import React, { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import "../App.css";
import Api from "./api/api";
import { AuthContext } from "../context/AuthContext";

const MySidebar = () => {
  var history = useHistory();
  const [path, setPath] = useState(history.path);
  const [unread, setUnread] = useState(0);
  const [newRequests, setNewRequests] = useState(0);

  const { user, setUser, isLoggedIn } = useContext(AuthContext);

  useEffect(() => {
    if (isLoggedIn) {
      loadUnreadCount();
      loadRequests();
    }
  }, []);

  const loadUnreadCount = () => {
    Api.getAllChats(
      (response) => {
        if (response.status === "success") {
          let models = response.data;
          let count = 0;
          for (let i = 0; i < models.length; i++) {
            const model = models[i];
            count = count + model.unread;
          }
          setUnread(count);
        }
      },
      (error) => {
        //
      }
    );
  };

  const loadRequests = () => {
    Api.getRecommendationRequests(
      (response) => {
        let count = 0;
        for (let i = 0; i < response.data.length; i++) {
          const item = response.data[i];
          if (item.admin_read == null || item.admin_read == 0) {
            count++;
          }
        }
        setNewRequests(count);
      },
      (error) => {
        //
      }
    );
  };

  const logoutUser = () => {
    // let user = MyStorage.getUser();
    Api.logoutUser(
      user.id,
      (response) => {
        setUser(null);
        history.push("/login");
      },
      (error) => {
        //
      }
    );
  };

  // check session
  // if (!MyStorage.isLogin()) {
  //     let url = window.location.href
  //     if(!url.includes('/download')){
  //         return <Redirect to='/login' />;
  //     }
  //     else{
  //         console.log('TEST');
  //     }
  // }

  return (
    <div>
      <div
        style={{
          height: "90vh",
          width: 200,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "black",
          paddingTop: 5,
        }}
      >
        <NavItem path={path} setPath={setPath} pathname="/">
          Dashboard
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/users">
          Users
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/library">
          Video Library
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/special-library">
          Special Library
        </NavItem>
        <NavItem
          path={path}
          setPath={setPath}
          pathname="/assign-programs"
          onClick={() => setNewRequests(0)}
        >
          Requests
          {"" + newRequests === "0" ? null : <div style={notificationStyle}>{newRequests}</div>}
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/banners">
          Banners
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/equipment">
          Equipment Needs
        </NavItem>

        <NavItem path={path} setPath={setPath} pathname="/messages" onClick={() => setUnread(0)}>
          Messages
          {"" + unread === "0" ? null : <div style={notificationStyle}>{unread}</div>}
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/send-email">
          Send Email
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/send-notification">
          Send Notification
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/guide-videos">
          Guide Videos
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/settings-pro">
          Professionals
        </NavItem>
        {/* <NavItem path={path} setPath={setPath} pathname="/add-code">
          Add Code
        </NavItem> */}
        <NavItem path={path} setPath={setPath} pathname="/settings">
          Settings
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/subscription-ad">
          Professionals
        </NavItem>
        <NavItem pathname="/codes" path={path} setPath={setPath}>
          Codes
        </NavItem>
        <NavItem path={path} setPath={setPath} pathname="/logout" onClick={() => logoutUser()}>
          Logout
        </NavItem>
      </div>
    </div>
  );
};

const notificationStyle = {
  marginLeft: 10,
  width: 20,
  height: 20,
  borderRadius: 10,
  backgroundColor: "red",
  color: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 12,
};

const NavItem = ({ pathname, path, setPath, onClick, children }) => {
  return (
    <Link
      style={{ textDecoration: "none" }}
      to={{
        pathname,
      }}
    >
      <div
        onClick={() => {
          onClick && onClick();
          setPath(pathname);
        }}
        className="menu-item"
        style={{
          backgroundColor: path === pathname ? "gray" : "black",
          display: "flex",
          alignItems: "center",
        }}
      >
        {children}
      </div>
    </Link>
  );
};

export default MySidebar;
